import { MShopUtilF } from '../../../../MShop/Util/F/Function/module/MShopUtilF.js';
import { MuiF } from '../../../../Mui/F/Function/module/MuiF.js';
import { html } from 'fxjs/es';
import { NessLabsReloadDescriptionMuiF } from '../Mui/module/NessLabsReloadDescriptionMuiF.js';
import { arrowIcon, gerRectangleIcon } from '../../../../Ness/Core/S/Tmpl/icon.js';

export const openReloaddescription = async () => {
  return MuiF.openFrame(NessLabsReloadDescriptionMuiF.frame, (frame, page, [tab]) => {
    const is_mobile = MShopUtilF.isMobile();
    frame.hide_frame_button_type = 'X';
    frame.height = is_mobile ? Math.floor(window.innerHeight * 0.85) : undefined;
    frame.always_remove = true;
    frame.animation = true;
    frame.prev_frame_show = true;
    frame.is_modal = !is_mobile;
    if (is_mobile) {
      MShopUtilF.bodyFixed$(true);

      frame.closed = () => {
        MShopUtilF.bodyFixed$(false);
      };
    }

    tab.template = () => {
      return html`
        <div class="notice-popup">
          <div class="notice-popup__header">다음과 같은 경우 캐릭터가 보이지 않을 수 있어요!</div>

          <ul class="notice-popup__list">
            <li class="notice-popup__item">
              <div class="notice-popup__item-title">
                ${gerRectangleIcon()}캐릭터의 최종 접속일이 2023년 12월 21일 이전인 경우
              </div>
              <div class="notice-popup__item-desc">
                ${arrowIcon()} 해당 캐릭터로 게임에 접속한 후 다시 시도해주세요.
              </div>
              <div class="notice-popup__divider"></div>
            </li>

            <li class="notice-popup__item">
              <div class="notice-popup__item-title">
                ${gerRectangleIcon()}실물 제작이 불가능한 아이템을 착용한 경우
              </div>
              <div class="notice-popup__item-desc">
                ${arrowIcon()} 게임에 접속하여 해당 아이템 해제 후 다시 시도해주세요.
              </div>
              <div class="notice-popup__divider"></div>
            </li>

            <li class="notice-popup__item">
              <div class="notice-popup__item-title">
                ${gerRectangleIcon()}게임에 업데이트된 신규 코디 아이템을 바로 착용한 경우
              </div>
              <div class="notice-popup__item-desc">
                ${arrowIcon()}게임과 LABS 데이터 동기화에 시간이 소요되며, 상황에 따라 작업이 다소 오래 걸릴
                수 있어요.
              </div>
              <div class="notice-popup__divider"></div>
            </li>

            <li class="notice-popup__item">
              <div class="notice-popup__item-title">
                ${gerRectangleIcon()}스페셜 월드 캐릭터 / 게임 이용이 제한된 계정 내 캐릭터
              </div>
              <div class="notice-popup__divider"></div>
            </li>
            <li class="notice-popup__item">
              <div class="notice-popup__item-title">
                ${gerRectangleIcon()}이펙트가 큰 아이템을 착용 후 캐릭터 모션을 변경한 경우
              </div>
              <div class="notice-popup__item-desc">
                ${arrowIcon()}특정 모션에서 이펙트가 일부 영역을 가리거나 어색하게 보일 수 있어요.
              </div>
              <div class="notice-popup__divider"></div>
            </li>
          </ul>

          <div class="notice-popup__footer">
            <div class="notice-popup__info">
              위 경우에 해당하지 않거나 문제가 지속될 경우, 넥슨에센셜 고객센터로 문의 부탁 드립니다.
            </div>

            <div class="notice-popup__note">
              ※ 게임에서 코디 아이템을 변경한 경우, LABS 반영에 시간이 다소 소요될 수 있습니다.
              <span class="notice-popup__note-span">약 10분 내외</span>
            </div>
          </div>
        </div>
      `;
    };
  });
};
